import { render, staticRenderFns } from "./BilletsDetails.vue?vue&type=template&id=71ce073c"
import script from "./BilletsDetails.vue?vue&type=script&lang=js"
export * from "./BilletsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports